import CloseIcon from "@mui/icons-material/Close";
import {
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  FormControlLabel,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMessages } from "./MessagesContext";
import { getAllMessageLogs } from "./utils";

const AllMessageLogs = () => {
  const [open, setOpen] = useState(false);
  const { viewAllLogs, setViewAllLogs } = useMessages();
  const [allLogs, setAllLogs] = useState(null);
  const [loading, setLoading] = useState(false);
  const [includeAutoGenerated, setIncludeAutoGenerated] = useState(false);

  useEffect(() => {
    setOpen(viewAllLogs);

    if (viewAllLogs) {
      setLoading(true);
      setAllLogs(null);

      getAllMessageLogs(
        null,
        (data) => {
          setAllLogs(data);
          setLoading(false);
        },
        includeAutoGenerated,
      );
    }
  }, [viewAllLogs, includeAutoGenerated]);

  const onClose = (e, reason) => {
    setViewAllLogs(false);
    setAllLogs(null);
    setIncludeAutoGenerated(false);
  };

  const convertDateISOToUTC = (isoDate) => {
    if (isoDate !== null && isoDate !== "") {
      const date = new Date(isoDate);
      const utcFormatted = `${date.getUTCFullYear()}-${String(
        date.getUTCMonth() + 1,
      ).padStart(
        2,
        "0",
      )}-${String(date.getUTCDate()).padStart(2, "0")} ${String(
        date.getUTCHours(),
      ).padStart(2, "0")}:${String(date.getUTCMinutes()).padStart(
        2,
        "0",
      )}:${String(date.getUTCSeconds()).padStart(2, "0")}`;
      return utcFormatted;
    } else return "";
  };

  return (
    <Dialog fullWidth={true} onClose={onClose} open={open} fullScreen={true}>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <Card sx={{ borderRadius: 3, overflow: "auto" }}>
        <CardHeader
          title={<font className="layer-title">All Message Logs</font>}
          sx={{ pb: 1, paddingLeft: 1, paddingRight: 1 }}
          align="center"
          className={"styledtablerow"}
        />
        <CardContent sx={{ paddingTop: 1, paddingLeft: 0, paddingRight: 0 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 2,
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeAutoGenerated}
                  onChange={(e) => setIncludeAutoGenerated(e.target.checked)}
                />
              }
              label="Auto-Generated"
            />
          </Box>
          {loading && (
            <Box
              sx={{
                display: "flex",
                alignContent: "center",
                alignItems: "center",
                padding: 10,
                width: "100%",
              }}
            >
              <CircularProgress sx={{ margin: "auto" }} />
            </Box>
          )}

          {!loading &&
            allLogs &&
            allLogs.content &&
            allLogs.content.length > 0 && (
              <Table size="small">
                <TableHead>
                  <TableRow className="styledtablerow">
                    <TableCell>Message ID</TableCell>
                    <TableCell>Text</TableCell>
                    <TableCell>startDate</TableCell>
                    <TableCell>expirationDate</TableCell>
                    <TableCell>AmberAlert</TableCell>
                    <TableCell>Priority</TableCell>
                    <TableCell>User</TableCell>
                    <TableCell>Update Date</TableCell>
                    <TableCell>Update Type</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allLogs.content.map((log, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{log.messageId}</TableCell>
                      <TableCell>
                        <span
                          dangerouslySetInnerHTML={{ __html: log.text }}
                        ></span>
                      </TableCell>
                      <TableCell>
                        {convertDateISOToUTC(log.startDate)}
                      </TableCell>
                      <TableCell>
                        {convertDateISOToUTC(log.expirationDate)}
                      </TableCell>
                      <TableCell>{log.amberAlert}</TableCell>
                      <TableCell>{log.priority}</TableCell>
                      <TableCell>{log.userName}</TableCell>
                      <TableCell>
                        {convertDateISOToUTC(log.updateDate)}
                      </TableCell>
                      <TableCell>{log.updateType}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}

          {!loading &&
            allLogs &&
            allLogs.content &&
            allLogs.content.length === 0 && (
              <Typography sx={{ textAlign: "center", m: 2 }} variant="h6">
                No logs found
              </Typography>
            )}
        </CardContent>
      </Card>
    </Dialog>
  );
};

export default AllMessageLogs;
